import { render, staticRenderFns } from "./uploadResource.vue?vue&type=template&id=272dfa60&scoped=true&"
import script from "./uploadResource.vue?vue&type=script&lang=js&"
export * from "./uploadResource.vue?vue&type=script&lang=js&"
import style0 from "./uploadResource.vue?vue&type=style&index=0&id=272dfa60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272dfa60",
  null
  
)

export default component.exports